import { cn } from '@/lib/utils';

export const PageContainer = ({
  children,
  className,
}: {
  children: React.ReactNode;
  className?: string;
}) => {
  return <div className={cn('container mx-auto py-4 lg:px-3', className)}>{children}</div>;
};
